import mutations from './mutations'
import actions from './actions'

const state = {
  facility_allocations: [],
  deleted_facility_allocations: []
}

export default {
  state, mutations, actions
}
